export default __webpack_public_path__ + "static/media/calendar-icon.66585337.png";